module.exports = __webpack_public_path__ + "static/media/sheep-dancing.07158af2.gif";